import { Table as BaseTable, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)<{ 'data-border-style'?: string | boolean }>`
  position: relative;
  display: flex;
  flex: 1;
  overflow: hidden;

  tr {
    position: relative;

    :not(.TableStickyRow):not(.TableHeaderRow) {
      :not(.TableStickyRowsDivider) {
        th {
          /* background: ${(p) => p.theme.palette.background.paper}; */
        }
      }
    }

    &.TableStickyRow {
      &,
      td,
      th {
        border-bottom: none !important;
      }
    }

    &:not(.TableStickyRowsDivider) {
      td {
        /* background: transparent; */
      }
    }
  }

  tbody {
    th {
      border: 1px solid ${(p) => p.theme.palette.grey[300]};
    }
  }

  &.bordered {
    border: 1px solid ${(p) => p.theme.palette.grey[300]};
    border-radius: ${(p) => p.theme.shape.borderRadius}px;

    th,
    td {
      border-width: 0px;
      border-style: solid;
      border-bottom-width: 1px;
      border-color: ${(p) => p.theme.palette.grey[300]};

      :not(:last-child) {
        border-right-width: 1px;
      }
    }

    td {
      border-style: ${(p) => p['data-border-style'] || 'solid'};
    }

    tr:last-child {
      td {
        border-bottom-style: solid;
      }
      td:last-child {
        border-bottom-right-radius: ${(p) => p.theme.shape.borderRadius}px;
      }
    }

    th {
      border-color: ${(p) => p.theme.palette.grey[300]};

      td:first-of-type {
        border-top-left-radius: ${(p) => p.theme.shape.borderRadius}px;
      }
      td:last-child {
        border-top-right-radius: ${(p) => p.theme.shape.borderRadius}px;
      }
    }
  }

  .TableRowSelectCell {
    width: 0;
    border-right: none !important;
    /* padding-right: 0; */
  }

  .TableRowSelectCell + :is(td, th) {
    padding-left: 0;
  }

  &.notFound {
    /* border: none; */
  }

  &.notFound.hideHeader {
    table {
      height: 100%;

      td,
      th {
        border: none !important;
        display: flex;
        align-items: center;
        height: 100%;
      }
    }
  }
`;

export const Table = styled(BaseTable)``;
